import React from 'react';

const CompareCard = (props) => {

  let ref = props.compkpi == '' ? 1 : 0;

  let evol = 0;

  if (ref == 0) {
    evol = (props.compkpi - props.refkpi);
  }

  return (
    <React.Fragment>
      <div className="col-xl-3 col-lg-4 col-6 pt-2">

        <div className="card h-100 border-dark mb-3" style={{ backgroundColor: props.color ? props.color : '' }}>

          <div className="card-body text-center align-items-center justify-content-center" style={{ color: "#4d0077" }}>

            {ref == 0 ?
              props.name == 'hours' || props.name == 'kms' || props.name == 'trips' || props.name == 'otp' ?
                <h3 className="card-title">{props.compkpi.toFixed(1) + '%'} ({evol > 0 ? '+' + evol.toFixed(1) + '%' : evol.toFixed(1) + '%'})</h3> :
                props.name == 'veh' ? <h3 className="card-title">{props.compkpi.toFixed(0)} ({evol > 0 ? '+' + evol.toFixed(0) : evol.toFixed(0)})</h3> :
                  <h3 className="card-title">{props.compkpi.toFixed(1)} ({evol > 0 ? '+' + evol.toFixed(1) : evol.toFixed(1)})</h3>
              :
              props.name == 'hours' || props.name == 'kms' || props.name == 'trips' || props.name == 'otp' ?
                <h3 className="card-title">{props.refkpi.toFixed(1) + '%'}</h3> :
                props.name == 'veh' ? <h3 className="card-title">{props.refkpi.toFixed(0)}</h3> :
                  <h3 className="card-title">{props.refkpi.toFixed(1)}</h3>}

            {props.name == 'hours' || props.name == 'kms' || props.name == 'trips' ?
              <div className="card-text">
                <div>{props.actual.toLocaleString('fr-CA') + ' / ' + props.planned.toLocaleString('fr-CA')}</div>
              </div> :
              ''}

          </div>

        </div>

      </div>
    </React.Fragment>
  )

}

export default CompareCard;
